export default __webpack_public_path__ + "static/media/bg_new.fc268f58.png";